/* eslint-disable jsx-a11y/anchor-is-valid */
import type { FC } from "react";
import { Fragment, useEffect } from "react";
import { useState } from "react";
import NavbarSidebarLayout from "../layouts/navbar-sidebar";
import kanbanBoards from "../data/kanban.json";
import { ReactSortable } from "react-sortablejs";
import { Button, Label, Modal, Textarea, TextInput } from "flowbite-react";
import { formatDistanceToNow } from 'date-fns';
import {
  HiArrowsExpand,
  HiClipboard,
  HiClipboardCopy,
  HiEye,
  HiFolder,
  HiPaperClip,
  HiPencilAlt,
  HiPlus,
} from "react-icons/hi";
import { PiDotsNineBold } from "react-icons/pi";
import toast, { Toaster } from 'react-hot-toast';
import { useAppContext } from "../context/AppContext";

interface KanbanBoard {
  id: number;
  title: string;
  tasks: KanbanItem[];
}

interface KanbanItem {
  id: number;
  name: string;
  description: string;
  completed: boolean;
  daysLeft: number;
  attachment?: string;
  members: KanbanItemMember[];
}

interface KanbanItemMember {
  id: number;
  name: string;
  avatar: string;
}

const KanbanPage: FC = function () {
  const [list, setList] = useState<KanbanBoard[]>(kanbanBoards);

  return (
    // <NavbarSidebarLayout isFooter={false}>
      <div className="overflow-x-auto">
        <div className="inline-block min-w-full align-middle">
          <div className="mb-6 flex items-start justify-start space-x-4 px-4">
            {list.map((board) => (
              <div key={board.id}>
                <div className="py-4 text-base font-semibold text-gray-900 dark:text-gray-300">
                  {board.title}
                </div>
                <div className="mb-6 space-y-4">
                  <ReactSortable
                    animation={100}
                    forceFallback
                    group="kanban"
                    list={board.tasks}
                    setList={(tasks) =>
                      setList((list) => {
                        const newList = [...list];
                        const index = newList.findIndex(
                          (item) => item.id === board.id
                        );
                        newList[index]!.tasks = tasks;
                        return newList;
                      })
                    }
                  >
                    {board.tasks.map((task) => (
                      <div
                        key={task.id}
                        className="mb-4 w-[28rem] cursor-grab rounded-lg bg-white p-4 shadow-md dark:bg-gray-800"
                      >
                        <div className="flex items-center justify-between pb-4">
                          <div className="text-base font-semibold text-gray-900 dark:text-white">
                            {task.name}
                          </div>
                          <div className="w-8">
                            {/* <EditPaymentCardModal /> */}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {task.attachment && (
                            <img
                              alt=""
                              src={task.attachment}
                              className="mb-3 rounded-lg"
                            />
                          )}
                          <div className="pb-4 text-sm font-normal text-gray-700 dark:text-gray-400">
                            {task.description}
                          </div>
                          <div className="flex justify-between">
                            <div className="flex items-center justify-start">
                              {task.members.map((member) => (
                                <Fragment key={member.id}>
                                  <a href="#" className="-mr-3">
                                    <img
                                      alt={member.name}
                                      src={`https://flowbite.com/application-ui/demo/images/users/${member.avatar}`}
                                      className="h-7 w-7 rounded-full border-2 border-white dark:border-gray-800"
                                    />
                                  </a>
                                  <div className="invisible absolute z-50 inline-block rounded-lg bg-gray-900 py-2 px-3 text-sm font-medium text-white opacity-0 shadow-sm transition-opacity duration-300 dark:bg-gray-700">
                                    {member.name}
                                  </div>
                                </Fragment>
                              ))}
                            </div>
                            <div className="flex items-center justify-center rounded-lg bg-purple-100 px-3 text-sm font-medium text-purple-800 dark:bg-purple-200">
                              <svg
                                className="mr-1 h-4 w-4"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                              7 days left
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </ReactSortable>
                </div>
                {/* <AddAnotherCardModal /> */}
              </div>
            ))}
          </div>
        </div>
      </div>
    // </NavbarSidebarLayout>
  );
};

interface EditPaymentCardModalProps {
  payment: any;
  member: any;
}
export const EditPaymentCardModal: FC<EditPaymentCardModalProps> = function ({ payment, member }) {
  const [isOpen, setOpen] = useState(false);
  const [plan, setPlan] = useState(payment.plan || '');
  const [plans, setPlans] = useState<string[]>([]);
  const [isPaid, setIsPaid] = useState(payment.isPaid);
  const [comments, setComments] = useState(payment.comments || '');
  const [selectedPlan, setSelectedPlan] = useState(payment.plan?._id || '');
  const { dummy, setDummy } = useAppContext();
  const user = sessionStorage.getItem("user");
  if (!user) {
    toast.error("User not found in session storage.");
    return;
  }

  const parsedUser = JSON.parse(user);
  const ownerId = parsedUser._id;
  const handlePlanChange = (e: any) => {
    const newPlanId = e.target.value;
    setSelectedPlan(newPlanId);
    setPlan(newPlanId); // Ensure this function updates payment correctly
  };

  useEffect(() => {
    setIsPaid(payment.isPaid); // Sync the local state with the prop
  }, [payment]);

  // Fetch plans from external API when component mounts
  // useEffect(() => {
  //   const fetchPlans = async () => {
  //     try {
  //       const response = await planService.getPlanOByOwnerId(ownerId);
  //       setPlans(response.data.data);
  //     } catch (error) {
  //       toast.error('Failed to load plans.');
  //     }
  //   };
  //   fetchPlans();
  // }, []);

  // const handleSave = async () => {
  //   try {
  //     const data = {
  //       isPaid,
  //       comments,
  //       plan,
  //     }
  //     // Call the update API
  //     const response = await memberService.updatePaymentRecord(member._id, payment._id, data);
  //     setDummy(!dummy)
  //     // Play success sound
  //     const audio = new Audio('/cash.mp3'); // Ensure the file exists in the public folder
  //     audio.play();
  //     toast.success('Payment record updated successfully');
  //     setOpen(false);
  //   } catch (error: any) {
  //     toast.error(error.message || 'Failed to update payment record.');
  //   }
  // };


  console.log("htiispayment", payment, member)
  return (
    <>
      <button
        onClick={() => { setOpen(true); setDummy(!dummy) }}
        className="flex w-10 h-10 items-center justify-center rounded-lg border-2 border-transparent py-2 font-semibold text-gray-500 hover:border-gray-300 hover:bg-gray-100 hover:text-gray-900 dark:border-gray-800 dark:hover:border-gray-700 dark:hover:bg-gray-800 dark:hover:text-white"
      >
        <span className="sr-only">Edit card</span>
        <PiDotsNineBold className="dark:text-white text-3xl" />
      </button>
      <Modal onClose={() => setOpen(false)} show={isOpen}>
        <Modal.Header className="border-b border-gray-200 !p-6 dark:border-gray-700">
          <strong>Update Payment: {payment?.month}</strong>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-between items-center">
            <div>
              <div className="mb-3 flex items-center text-2xl font-semibold leading-none text-gray-900 dark:text-white">

                {member.profilePhoto && member.profilePhoto !== "null" ? (
                  <img
                    className="h-9 w-9 rounded-full border-2 border-white dark:border-gray-800"
                    src={member.profilePhoto}
                    alt={`${member.fullName} avatar`}
                  />
                ) : (
                  <img
                    className="h-9 w-9 rounded-full border-2 border-white dark:border-gray-800"
                    src={`https://api.dicebear.com/9.x/initials/svg?seed=${member.fullName}`}
                    alt={`${member.fullName} avatar`}
                  />

                )}
                <p className="ml-2">{member?.fullName}</p>
              </div>
              <div className="mb-5 flex flex-col items-start justify-center space-y-3">
                <div className="text-sm text-gray-500 dark:text-gray-400">
                  Updated by{" "}
                  <a className="cursor-pointer text-primary-700 no-underline hover:underline dark:text-primary-500">
                    {parsedUser?.ownerName}
                  </a>
                  , {formatDistanceToNow(new Date(member?.updatedAt)) + ' ago'}
                </div>
              </div>
            </div>
            <label className="inline-flex items-center me-5 cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={isPaid}
                onChange={(e) => setIsPaid(e.target.checked)}
              />
              <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600" />
              <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                {isPaid ? "Paid" : "Unpaid"}
              </span>
            </label>
          </div>
          <div className="py-4">
            <select
              id="plan"
              name="plan"
              value={selectedPlan}
              onChange={handlePlanChange}
              className="bg-gray-50 border text-gray-900 text-sm rounded-lg w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
              <option value="">Select Plan</option>
              {plans.map((plan: any) => (
                <option key={plan._id} value={plan._id}>
                  {plan.planName}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4 w-full rounded-lg border border-gray-100 bg-gray-100 dark:border-gray-600 dark:bg-gray-700">
            <div className="p-4">
              <textarea
                id="compose-mail"
                rows={4}
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                className="block w-full border-0 bg-gray-100 px-0 text-base text-gray-900 focus:ring-0 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400"
                placeholder="Write a comment..."
              ></textarea>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="grid w-full grid-cols-2 items-center gap-3 sm:grid-cols-5">
            <Button color="primary" onClick={()=>{}}>
              <div className="flex items-center gap-x-2">
                <HiClipboard className="text-xl" />
                Save
              </div>
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};


interface AddPaymentCardModalProps {
  memberId: string;
}

export const AddPaymentCardModal: FC<AddPaymentCardModalProps> = ({ memberId }) => {
  const [isOpen, setOpen] = useState(false);
  const [monthsToPay, setMonthsToPay] = useState(1);
  const [plan, setPlan] = useState('');
  const [plans, setPlans] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  // const { dummy, setDummy } = useAppContext();
  const user = sessionStorage.getItem("user");
  if (!user) {
    toast.error("User not found in session storage.");
    return;
  }

  const parsedUser = JSON.parse(user);
  const ownerId = parsedUser._id;
  // Fetch plans from external API when component mounts
  // useEffect(() => {
  //   const fetchPlans = async () => {
  //     try {
  //       const response = await planService.getPlanOByOwnerId(ownerId);
  //       setPlans(response.data.data);
  //     } catch (error) {
  //       toast.error('Failed to load plans.');
  //     }
  //   };

  //   fetchPlans();
  // }, []);

  // const handleSubmit = async () => {
  //   try {
  //     setIsLoading(true);

  //     // Validate inputs
  //     if (!memberId || monthsToPay <= 0 || !plan) {
  //       throw new Error('Member ID, plan, and a valid months to pay are required.');
  //     }

  //     const response = await memberService.addPaymentRecord({ memberId, monthsToPay, plan });

  //     if (response.status === 200) {
  //       // Play success sound
  //       const audio = new Audio('/cash.mp3'); // Ensure the file exists in the public folder
  //       audio.play();
  //       setDummy(!dummy);
  //       setMonthsToPay(1);
  //       setPlan('');
  //       toast.success('Payment record added successfully!');
  //       setOpen(false); // Close modal on success

  //     } else {
  //       toast.error('Failed to add payment record');
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message || 'An error occurred while adding payment.');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };



  return (
    <>
      <div className="relative flex items-center justify-center group">
        <button
          onClick={() => setOpen(true)}
          data-tooltip-target="tooltip-new"
          type="button"
          className="inline-flex items-center justify-center w-10 h-10 font-medium bg-blue-600 rounded-full hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 focus:outline-none dark:focus:ring-blue-800"
        >
          <svg
            className="w-4 h-4 text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 18 18"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 1v16M1 9h16"
            />
          </svg>
          <span className="sr-only">New item</span>
        </button>

        <div
          className="absolute top-full mt-2 px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm opacity-0 transition-opacity duration-300 group-hover:opacity-100 group-hover:block dark:bg-gray-700 whitespace-nowrap"
          role="tooltip"
        >
          Add New Payment
        </div>
      </div>

      <Modal onClose={() => setOpen(false)} show={isOpen}>
        <Modal.Header className="border-b border-gray-200 !p-6 dark:border-gray-700">
          <strong>Add New Payment</strong>
        </Modal.Header>
        <Modal.Body>
          <form>


            <div className="mb-4 grid grid-cols-1 gap-y-2">
              <Label htmlFor="monthsToPay">Months to Pay</Label>
              <TextInput
                type="number"
                id="monthsToPay"
                name="monthsToPay"
                value={monthsToPay}
                onChange={(e) => setMonthsToPay(Number(e.target.value))}
                placeholder="Number of months"
              />
            </div>

            <div className="mb-4 grid grid-cols-1 gap-y-2">
              <Label htmlFor="plan">Plan</Label>
              {/* <select
                id="plan"
                name="plan"
                value={plan}
                onChange={(e) => setPlan(e.target.value)}
              >
                <option value="">Select a plan</option>
                {plans.map((planOption, index) => (
                  <option key={index} value={planOption}>
                    {planOption}
                  </option>
                ))}
              </select> */}
              <select
                id="plan"
                name="plan"
                value={plan}
                onChange={(e) => setPlan(e.target.value)}
                className="bg-gray-50 border text-gray-900 text-sm rounded-lg w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="">Select Plan</option>
                {plans.map((plan: any) => (
                  <option key={plan._id} value={plan._id}>
                    {plan.planName}
                  </option>
                ))}
              </select>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex items-center gap-x-3">
            <Button color="primary" onClick={()=>{}} disabled={isLoading}>
              <div className="flex items-center gap-x-2">
                <HiPlus className="text-lg" />
                {isLoading ? 'Processing...' : 'Add Payment'}
              </div>
            </Button>
            {/* <Button color="gray" onClick={() => setOpen(false)}>
              Close
            </Button> */}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};


export default KanbanPage;
